import {
  SignalStageSchema,
  type SignalStageType,
} from '@terra/shared-schemas-orchestrator';
import type {
  SignalCountsFilters,
  SignalCountsResult,
} from '../../../hooks/useSignalCounts';

export const SIGNALS_STAGE_CHIP_ALL = 'ALL';

export type SignalsStageChip = typeof SIGNALS_STAGE_CHIP_ALL | SignalStageType;

export const SIGNALS_STAGE_CHIPS: readonly SignalsStageChip[] = [
  SIGNALS_STAGE_CHIP_ALL,
  ...SignalStageSchema.options,
];

export const resolveSignalsStageChip = (
  stageFilter: readonly SignalStageType[],
): SignalsStageChip | null => {
  if (stageFilter.length === 0) {
    return SIGNALS_STAGE_CHIP_ALL;
  }

  return stageFilter.length === 1 ? stageFilter[0] : null;
};

export const toSignalsStageFilter = (
  chip: SignalsStageChip,
): SignalStageType[] => (chip === SIGNALS_STAGE_CHIP_ALL ? [] : [chip]);

export const resolveSignalsStageChipCount = ({
  chip,
  stageCounts,
}: {
  chip: SignalsStageChip;
  stageCounts: SignalCountsResult | undefined;
}): number | undefined => {
  if (!stageCounts) {
    return undefined;
  }

  if (chip === SIGNALS_STAGE_CHIP_ALL) {
    return stageCounts.counts.ALL;
  }

  if (!stageCounts.byStage) {
    return undefined;
  }

  return stageCounts.byStage[chip] ?? 0;
};

export const buildSignalStageChipCountsFilters = (
  countsFilters: SignalCountsFilters,
): SignalCountsFilters => ({ ...countsFilters, stage: undefined });
